import { render, staticRenderFns } from "./NextAutomationAlert.vue?vue&type=template&id=237e228e&"
import script from "./NextAutomationAlert.vue?vue&type=script&lang=js&"
export * from "./NextAutomationAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports